import { graphql } from "relay-runtime"

export const deCreateOrReuseEpisodeOfCareMutation = graphql`
  mutation deCreateOrReuseEpisodeOfCareMutation($input: De_createOrReuseEpisodeOfCareInput!, $addConnections: [ID!]!) {
    createOrReuseEpisodeOfCare: de_createOrReuseEpisodeOfCare(input: $input) {
      episodeOfCare: de_EpisodeOfCare @prependNode(connections: $addConnections, edgeTypeName: "de_EpisodeOfCareEdge") {
        id
        ...deEpisodeOfCareFragment
      }
    }
  }
`
